<template>
  <div class="dropshipping">
    <div class="module1 f">
      <div class="box f-b-c">

        <template v-if="isPC">
          <div class="left">
            <div class="subtitle" @mouseover="changeSubtitleStyle(true)" @mouseout="changeSubtitleStyle(false)">
              <div class="subtitleImg" @click="playPCVideo('https://img.kakaclo.com/web-img/home/video/video/7.mp4')">
                <oss-img :width="20" :height="20" :src="subtitleImgSrc" alt="img" />
              </div>
              <div>
                <span  @click="playPCVideo('https://img.kakaclo.com/web-img/home/video/video/7.mp4')" :style="{ color: titleColor }">{{ $t('Dropshipping.Module1.Title1') }}</span>
              </div>
            </div>
            <h1>
              <div class="title2">
                <div>{{ $t('Dropshipping.Module1.Title2') }}</div>
                <div style="color: #9AC331;" class="title3">{{ $t('Dropshipping.Module1.Title3') }}</div>
                <div class="wireIcon">
                  <oss-img :width="327" :height="66" src="http://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/home/dropshipping/icon_img27.png" alt="img" />
                </div>
              </div>
              <div class="title">
                {{ $t('Dropshipping.Module1.Title4') }}
              </div>
            </h1>
            <div class="sub">{{ $t('Dropshipping.Module1.Sub1') }}</div>
            <div class="sub">{{ $t('Dropshipping.Module1.Sub3') }}</div>
            <div class="sub">{{ $t('Dropshipping.Module1.Sub2') }}</div>
            <el-button v-if="userId" class="btn" @click="jump('/mall')">{{ $t('Dropshipping.Module1.StartSelling') }}</el-button>
            <el-button v-else class="btn" @click="jump('/register')">{{ $t('Dropshipping.Module1.SignUpForFree') }}</el-button>
          </div>
          <div class="img">
            <oss-img :width="658" :height="458" src="https://img.kakaclo.com/web-img/home/dropshipping/pic_img1.png" alt="img" />
          </div>
        </template>

        <template v-else>
          <div class="mobileSubtitle" @mouseover="changeSubtitleStyle(true)" @mouseout="changeSubtitleStyle(false)">
            <div class="mobileSubtitleImg" @click="playMpbileVideo('https://img.kakaclo.com/web-img/home/video/video/7.mp4')">
              <oss-img :width="20" :height="20" :src="subtitleImgSrc" alt="img" />
            </div>
            <div>
              <span @click="playMpbileVideo('https://img.kakaclo.com/web-img/home/video/video/7.mp4')" :style="{ color: titleColor }">{{ $t('Dropshipping.Module1.Title1') }}</span>
            </div>
          </div>
          <h1>
            <div class="mobileTitle2">
              <div>{{ $t('Dropshipping.Module1.Title2') }}</div>
              <div style="color: #9AC331;" class="title3">{{ $t('Dropshipping.Module1.Title3') }}</div>
              <div class="wireIcon">
                <oss-img :width="209" :height="42" src="http://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/home/dropshipping/icon_m_img1_1.png" alt="img" />
              </div>
            </div>
            <div class="mobileTitle">
              {{ $t('Dropshipping.Module1.Title4') }}
            </div>
          </h1>
          <div class="mobileSub">{{ $t('Dropshipping.Module1.Sub1') }}</div>
          <div class="mobileSub">{{ $t('Dropshipping.Module1.Sub3') }}</div>
          <div class="mobileSub">{{ $t('Dropshipping.Module1.Sub2') }}</div>

          <el-button v-if="userId" class="btn" @click="jump('/mall')">{{ $t('Dropshipping.Module1.StartSelling') }}</el-button>
          <el-button v-else class="btn" @click="jump('/register')">{{ $t('Dropshipping.Module1.SignUpForFree') }}</el-button>
          <div class="img">
            <oss-img :width="343" :height="246" src="https://img.kakaclo.com/web-img/home/dropshipping/pic_m_img1.png" alt="img" />
          </div>
        </template>

      </div>

      <template v-if="isPC">
        <div class="platformLogo">
          <div class="platformLogoImg">
            <oss-img :width="120" :height="24" src="https://img.kakaclo.com/web-img/home/dropshipping/icon_img22.png" alt="tiktok" />
          </div>
          <div class="platformLogoImg">
            <oss-img :width="120" :height="24" src="https://img.kakaclo.com/web-img/home/dropshipping/icon_img23.png" alt="shopify" />
          </div>
          <div class="platformLogoImg">
            <oss-img :width="120" :height="24" src="https://img.kakaclo.com/web-img/home/dropshipping/icon_img24.png" alt="shoplazza" />
          </div>
          <div class="platformLogoImg">
            <oss-img :width="120" :height="24" src="https://img.kakaclo.com/web-img/home/dropshipping/icon_img25.png" alt="shopline" />
          </div>
          <div class="platformLogoImg">
            <oss-img :width="120" :height="24" src="https://img.kakaclo.com/web-img/home/dropshipping/icon_img26.png" alt="woocommerce" />
          </div>
        </div>
      </template>
      <template v-else>
        <div class="platformLogoTop">
          <div class="platformLogoImg">
            <oss-img :width="109" :height="22" src="https://img.kakaclo.com/web-img/home/dropshipping/icon_m_img2.png" alt="tiktok" />
          </div>
          <div class="platformLogoImg">
            <oss-img :width="109" :height="22" src="https://img.kakaclo.com/web-img/home/dropshipping/icon_m_img3.png" alt="shopify" />
          </div>
          <div class="platformLogoImg">
            <oss-img :width="109" :height="22" src="https://img.kakaclo.com/web-img/home/dropshipping/icon_m_img4.png" alt="shoplazza" />
          </div>
        </div>
        <div class="platformLogoBottom">
          <div class="platformLogoImg">
            <oss-img :width="109" :height="22" src="https://img.kakaclo.com/web-img/home/dropshipping/icon_m_img5.png" alt="shopline" />
          </div>
          <div class="platformLogoImg">
            <oss-img :width="109" :height="22" src="https://img.kakaclo.com/web-img/home/dropshipping/icon_m_img6.png" alt="woocommerce" />
          </div>
        </div>

      </template>

    </div>

    <div class="module2">
      <div class="box">

        <template v-if="isPC">
          <div class="title1">{{ $t('Dropshipping.Module2.Title1')}}</div>
          <div class="title1">
            <span>{{ $t('Dropshipping.Module2.Title2')}}</span>
            <span style="color: #9AC331;">{{ $t('Dropshipping.Module2.Title3')}}</span>
          </div>
          <div class="sub1">{{ $t('Dropshipping.Module2.Sub1') }}</div>
          <div class="item f-b-c">
            <div class="left">
              <div class="picImg">
                <oss-img :width="660" :height="608" src="https://img.kakaclo.com/web-img/home/dropshipping/pic_img2.png" alt="img" />
              </div>
              <div class="leftDescribe1">
                <div class="questions1">{{ $t('Dropshipping.Module2.Questions1') }}</div>
              </div>
              <div class="leftDescribe2" @click="playPCVideo('https://img.kakaclo.com/web-img/home/video/video/7.mp4')" @mouseover="changeBackgroundColor(true)" @mouseout="changeBackgroundColor(false)" :style="{ background: backgroundColor }">
                  <div class="linkUrl1">{{ $t('Dropshipping.Module2.LinkUrl1') }}</div>
              </div>

            </div>
            <div class="right">
              <div class="caption">
                <div class="captionImg">
                  <div class="captionImgSet">
                    <oss-img  :width="40" :height="40" src="http://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/home/dropshipping/icon_img2.png" alt="img" />
                  </div>
                </div>
                <div>
                  <span class="captionTitle">{{ $t('Dropshipping.Module2.CaptionTitle1') }}</span>
                  <span class="captionTitleAdditiona">{{ $t('Dropshipping.Module2.CaptionTitleAdditiona1') }}</span>
                </div>
              </div>
              <div class="caption">
                <div class="captionImg">
                  <div class="captionImgSet">
                    <oss-img  :width="40" :height="40" src="http://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/home/dropshipping/icon_img3.png" alt="img" />
                  </div>
                </div>
                <div>
                  <span class="captionTitle">{{ $t('Dropshipping.Module2.CaptionTitle2') }}</span>
                  <span class="captionTitleAdditiona">{{ $t('Dropshipping.Module2.CaptionTitleAdditiona2') }}</span>
                </div>
              </div>
              <div class="caption">
                <div class="captionImg">
                  <div class="captionImgSet">
                    <oss-img :width="40" :height="40" src="http://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/home/dropshipping/icon_img4.png" alt="img" />
                  </div>
                </div>
                <div>
                  <span class="captionTitle">{{ $t('Dropshipping.Module2.CaptionTitle3') }}</span>
                  <span class="captionTitleAdditiona">{{ $t('Dropshipping.Module2.CaptionTitleAdditiona3') }}</span>
                </div>
              </div>
              <div class="caption">
                <div class="captionImg">
                  <div class="captionImgSet">
                    <oss-img :width="40" :height="40" src="http://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/home/dropshipping/icon_img5.png" alt="img" />
                  </div>
                </div>
                <div>
                  <span class="captionTitle">{{ $t('Dropshipping.Module2.CaptionTitle4') }}</span>
                  <span class="captionTitleAdditiona">{{ $t('Dropshipping.Module2.CaptionTitleAdditiona4') }}</span>
                </div>
              </div>
              <div class="caption">
                <div class="captionImg">
                  <div class="captionImgSet">
                    <oss-img :width="20" :height="20" src="http://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/home/dropshipping/icon_img6.png" alt="img" />
                  </div>
                </div>
                <div>
                  <span class="captionTitle">{{ $t('Dropshipping.Module2.CaptionTitle5') }}</span>
                  <span class="captionTitleAdditiona"></span>
                </div>
              </div>
            </div>
          </div>

          <div class="title1" style=" margin-top: 228px;">{{ $t('Dropshipping.Module2.Title4')}}</div>
          <div class="sub1">{{ $t('Dropshipping.Module2.Sub2') }}</div>
          <div class="item f-b-c">
            <div class="left">
              <div class="selectReason">
                <div class="selectReasonImg">
                  <div class="selectReasonImgSet" >
                    <oss-img  :width="40" :height="40" src="http://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/home/dropshipping/icon_img7.png" alt="img" />
                  </div>
                </div>
                <div>
                  <span class="selectReasonTitle">{{ $t('Dropshipping.Module2.SelectReasonTitle1') }}</span>
                  <span class="selectReasonTitleAdditiona">{{ $t('Dropshipping.Module2.SelectReasonTitleAdditiona1') }}</span>
                </div>
              </div>
              <div class="selectReason">
                <div class="selectReasonImg">
                  <div class="selectReasonImgSet" >
                    <oss-img  :width="40" :height="40" src="http://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/home/dropshipping/icon_img9.png" alt="img" />
                  </div>
                </div>
                <div>
                  <span class="selectReasonTitle">{{ $t('Dropshipping.Module2.SelectReasonTitle3') }}</span>
                  <span class="selectReasonTitleAdditiona">{{ $t('Dropshipping.Module2.SelectReasonTitleAdditiona3') }}</span>
                </div>
              </div>
            </div>
            <div class="right">
              <div class="selectReason">
                <div class="selectReasonImg">
                  <div class="selectReasonImgSet" >
                    <oss-img  :width="40" :height="40" src="http://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/home/dropshipping/icon_img8.png" alt="img" />
                  </div>
                </div>
                <div>
                  <span class="selectReasonTitle">{{ $t('Dropshipping.Module2.SelectReasonTitle2') }}</span>
                  <span class="selectReasonTitleAdditiona">{{ $t('Dropshipping.Module2.SelectReasonTitleAdditiona2') }}</span>
                </div>
              </div>
              <div class="selectReason">
                <div class="selectReasonImg">
                  <div class="selectReasonImgSet" >
                    <oss-img  :width="40" :height="40" src="http://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/home/dropshipping/icon_img10.png" alt="img" />
                  </div>
                </div>
                <div>
                  <span class="selectReasonTitle">{{ $t('Dropshipping.Module2.SelectReasonTitle4') }}</span>
                  <span class="selectReasonTitleAdditiona">{{ $t('Dropshipping.Module2.SelectReasonTitleAdditiona4') }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="advantage">
            <div class="advantageDetails">
              <div class="advantageImg">
                <oss-img  :width="120" :height="120" src="http://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/home/dropshipping/icon_img11.png" alt="img" />
              </div>
              <div class="advantageTitle">{{ $t('Dropshipping.Module2.advantageTitle1') }}</div>
            </div>
            <div class="advantageDetails">
              <div class="advantageImg"  style="margin-left: 40px !important;">
                <oss-img  :width="120" :height="120" src="http://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/home/dropshipping/icon_img12.png" alt="img" />
              </div>
              <div class="advantageTitle">{{ $t('Dropshipping.Module2.advantageTitle2') }}</div>
            </div>
            <div class="advantageDetails">
              <div class="advantageImg" style="margin-left: 40px !important;">
                <oss-img  :width="120" :height="120" src="http://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/home/dropshipping/icon_img13.png" alt="img" />
              </div>
              <div class="advantageTitle">{{ $t('Dropshipping.Module2.advantageTitle3') }}</div>
            </div>
            <div class="advantageDetails">
              <div class="advantageImg" style="margin-left: 30px !important;">
                <oss-img  :width="120" :height="120" src="http://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/home/dropshipping/icon_img14.png" alt="img" />
              </div>
              <div class="advantageTitle">{{ $t('Dropshipping.Module2.advantageTitle4') }}</div>
            </div>
            <div class="advantageDetails">
              <div class="advantageImg"  style="margin-left: 30px !important;">
                <oss-img  :width="120" :height="120" src="http://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/home/dropshipping/icon_img15.png" alt="img" />
              </div>
              <div class="advantageTitle">{{ $t('Dropshipping.Module2.advantageTitle5') }}</div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="mobileTitle1">
            <span>{{ $t('Dropshipping.Module2.Title1')}}</span>
            <span>{{ $t('Dropshipping.Module2.Title2')}}</span>
            <span style="color: #9AC331;">{{ $t('Dropshipping.Module2.Title3')}}</span>
          </div>
          <div class="mobileSub">{{ $t('Dropshipping.Module2.Sub1') }}</div>

          <div class="mobilePicImg">
              <div class="mobilePicImgSet">
                <oss-img :width="343" :height="316" src="https://img.kakaclo.com/web-img/home/dropshipping/pic_m_img2.png" alt="img" />
              </div>
              <div class="mobileLeftDescribe1">
                <div class="questions1">{{ $t('Dropshipping.Module2.Questions1') }}</div>
              </div>
              <div class="mobileLeftDescribe2" @click="playMpbileVideo('https://img.kakaclo.com/web-img/home/video/video/7.mp4')" @mouseover="changeBackgroundColor(true)" @mouseout="changeBackgroundColor(false)" :style="{ background: backgroundColor }">
                <div class="linkUrl1">{{ $t('Dropshipping.Module2.LinkUrl1') }}</div>
              </div>
          </div>

          <div class="captionSet">
              <div class="caption">
                <div class="captionImg">
                  <div class="captionImgSet">
                    <oss-img  :width="40" :height="40" src="http://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/home/dropshipping/icon_img2.png" alt="img" />
                  </div>
                </div>
                <div>
                  <span class="captionTitle">{{ $t('Dropshipping.Module2.CaptionTitle1') }}</span>
                  <span class="captionTitleAdditiona">{{ $t('Dropshipping.Module2.CaptionTitleAdditiona1') }}</span>
                </div>
              </div>
              <div class="caption">
                <div class="captionImg">
                  <div class="captionImgSet">
                    <oss-img  :width="40" :height="40" src="http://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/home/dropshipping/icon_img3.png" alt="img" />
                  </div>
                </div>
                <div>
                  <span class="captionTitle">{{ $t('Dropshipping.Module2.CaptionTitle2') }}</span>
                  <span class="captionTitleAdditiona">{{ $t('Dropshipping.Module2.CaptionTitleAdditiona2') }}</span>
                </div>
              </div>
              <div class="caption">
                <div class="captionImg">
                  <div class="captionImgSet">
                    <oss-img :width="40" :height="40" src="http://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/home/dropshipping/icon_img4.png" alt="img" />
                  </div>
                </div>
                <div>
                  <span class="captionTitle">{{ $t('Dropshipping.Module2.CaptionTitle3') }}</span>
                  <span class="captionTitleAdditiona">{{ $t('Dropshipping.Module2.CaptionTitleAdditiona3') }}</span>
                </div>
              </div>
              <div class="caption">
                <div class="captionImg">
                  <div class="captionImgSet">
                    <oss-img :width="40" :height="40" src="http://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/home/dropshipping/icon_img5.png" alt="img" />
                  </div>
                </div>
                <div>
                  <span class="captionTitle">{{ $t('Dropshipping.Module2.CaptionTitle4') }}</span>
                  <span class="captionTitleAdditiona">{{ $t('Dropshipping.Module2.CaptionTitleAdditiona4') }}</span>
                </div>
              </div>
              <div class="caption">
                <div class="captionImg">
                  <div class="captionImgSet">
                    <oss-img :width="40" :height="40" src="http://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/home/dropshipping/icon_img6.png" alt="img" />
                  </div>
                </div>
                <div>
                  <span class="captionTitle">{{ $t('Dropshipping.Module2.CaptionTitle5') }}</span>
                  <span class="captionTitleAdditiona"></span>
                </div>
              </div>
            </div>

            <div class="mobileTitle1" style=" margin-top: 96px;">{{ $t('Dropshipping.Module2.Title4')}}</div>
            <div class="mobileSub">{{ $t('Dropshipping.Module2.Sub2') }}</div>
            <div class="selectReasonSet">
              <div class="selectReason">
                <div class="selectReasonImg">
                  <div class="selectReasonImgSet" >
                    <oss-img  :width="40" :height="40" src="http://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/home/dropshipping/icon_img7.png" alt="img" />
                  </div>
                </div>
                <div>
                  <span class="selectReasonTitle">{{ $t('Dropshipping.Module2.SelectReasonTitle1') }}</span>
                  <span class="selectReasonTitleAdditiona">{{ $t('Dropshipping.Module2.SelectReasonTitleAdditiona1') }}</span>
                </div>
              </div>
              <div class="selectReason">
                <div class="selectReasonImg">
                  <div class="selectReasonImgSet" >
                    <oss-img  :width="40" :height="40" src="http://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/home/dropshipping/icon_img9.png" alt="img" />
                  </div>
                </div>
                <div>
                  <span class="selectReasonTitle">{{ $t('Dropshipping.Module2.SelectReasonTitle3') }}</span>
                  <span class="selectReasonTitleAdditiona">{{ $t('Dropshipping.Module2.SelectReasonTitleAdditiona3') }}</span>
                </div>
              </div>
              <div class="selectReason">
                <div class="selectReasonImg">
                  <div class="selectReasonImgSet" >
                    <oss-img  :width="40" :height="40" src="http://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/home/dropshipping/icon_img8.png" alt="img" />
                  </div>
                </div>
                <div>
                  <span class="selectReasonTitle">{{ $t('Dropshipping.Module2.SelectReasonTitle2') }}</span>
                  <span class="selectReasonTitleAdditiona">{{ $t('Dropshipping.Module2.SelectReasonTitleAdditiona2') }}</span>
                </div>
              </div>
              <div class="selectReason">
                <div class="selectReasonImg">
                  <div class="selectReasonImgSet" >
                    <oss-img  :width="40" :height="40" src="http://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/home/dropshipping/icon_img10.png" alt="img" />
                  </div>
                </div>
                <div>
                  <span class="selectReasonTitle">{{ $t('Dropshipping.Module2.SelectReasonTitle4') }}</span>
                  <span class="selectReasonTitleAdditiona">{{ $t('Dropshipping.Module2.SelectReasonTitleAdditiona4') }}</span>
                </div>
              </div>
            </div>

            <div class="advantage">
              <div class="advantageTop">
                <div class="advantageDetails">
                  <div class="advantageImg">
                    <oss-img  :width="120" :height="96" src="http://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/home/dropshipping/icon_m_img7.png" alt="img" />
                  </div>
                  <div class="advantageTitle">{{ $t('Dropshipping.Module2.advantageTitle1') }}</div>
                </div>
                <div class="advantageDetails">
                  <div class="advantageImg">
                    <oss-img  :width="120" :height="96" src="http://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/home/dropshipping/icon_m_img8.png" alt="img" />
                  </div>
                  <div class="advantageTitle">{{ $t('Dropshipping.Module2.advantageTitle2') }}</div>
                </div>
              </div>
              <div class="advantageMiddle">
                <div class="advantageDetails">
                  <div class="advantageImg">
                    <oss-img  :width="120" :height="96" src="http://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/home/dropshipping/icon_m_img9.png" alt="img" />
                  </div>
                  <div class="advantageTitle">{{ $t('Dropshipping.Module2.advantageTitle3') }}</div>
                </div>
                <div class="advantageDetails">
                  <div class="advantageImg">
                    <oss-img  :width="120" :height="96" src="http://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/home/dropshipping/icon_m_img10.png" alt="img" />
                  </div>
                  <div class="advantageTitle">{{ $t('Dropshipping.Module2.advantageTitle4') }}</div>
                </div>
              </div>
              <div class="advantageBottom">
                <div class="advantageDetails">
                  <div class="advantageImg">
                    <oss-img  :width="120" :height="96" src="http://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/home/dropshipping/icon_m_img11.png" alt="img" />
                  </div>
                  <div class="advantageTitle">{{ $t('Dropshipping.Module2.advantageTitle5') }}</div>
                </div>
              </div>
            </div>

        </template>

      </div>
    </div>

    <div class="module3">
      <div class="box">

        <template v-if="isPC">
          <div  class="title1">{{ $t('Dropshipping.Module3.Title1') }}</div>
          <div class="instructionsImg">
            <oss-img :width="1062" :height="480" src="https://img.kakaclo.com/web-img/home/dropshipping/bg_img3.png" alt="img" />
          </div>
          <div class="box1">
            <div class="top f-b-c">
              <div class="instructions">
                <div class="title2 f--c">
                  <div class="round"></div>
                  <div>{{ $t('Dropshipping.Module3.Title2') }}</div>
                </div>
                <div class="sub2"> {{ $t('Dropshipping.Module3.Sub1') }}</div>
                <div class="triangle"></div>
              </div>
              <div class="instructions">
                <div class="title2 f--c">
                  <div class="round"></div>
                  <div>{{ $t('Dropshipping.Module3.Title4') }}</div>
                </div>
                <div class="sub2"> {{ $t('Dropshipping.Module3.Sub3') }}</div>
                <div class="triangle t-right"></div>
              </div>
            </div>

            <div class="bottom f-b-c">
              <div class="instructions">
                <div class="title2 f--c">
                  <div class="round"></div>
                  <div>{{ $t('Dropshipping.Module3.Title3') }}</div>
                </div>
                <div class="sub2">{{ $t('Dropshipping.Module3.Sub2') }}</div>
                <div class="triangle"></div>
              </div>
              <div class="instructions">
                <div class="title2 f--c">
                  <div class="round"></div>
                  <div>{{ $t('Dropshipping.Module3.Title5') }}</div>
                </div>
                <div class="sub2">{{ $t('Dropshipping.Module3.Sub4') }}</div>
                <div class="triangle t-right"></div>
              </div>
            </div>
          </div>
          <div class="foot-btn">
            <el-button class="btn" @click="jump('/mall')">{{ $t('Dropshipping.Module3.StartNow') }}</el-button>
          </div>
        </template>
        <template v-else>
          <div  class="mobileTitle1">{{ $t('Dropshipping.Module3.Title1') }}</div>
          <div class="instructionsSet">
            <div class="instructions">
                <div class="mobileTitle1 f--c">
                  <div class="round"></div>
                  <div>{{ $t('Dropshipping.Module3.Title2') }}</div>
                </div>
                <div class="mobileSub"> {{ $t('Dropshipping.Module3.Sub1') }}</div>
                <div class="triangle"></div>
              </div>

              <div class="instructions">
                <div class="mobileTitle1 f--c">
                  <div class="round"></div>
                  <div>{{ $t('Dropshipping.Module3.Title4') }}</div>
                </div>
                <div class="mobileSub"> {{ $t('Dropshipping.Module3.Sub3') }}</div>
                <div class="triangle"></div>
              </div>

              <div class="instructions">
                <div class="mobileTitle1 f--c">
                  <div class="round"></div>
                  <div>{{ $t('Dropshipping.Module3.Title3') }}</div>
                </div>
                <div class="mobileSub">{{ $t('Dropshipping.Module3.Sub2') }}</div>
                <div class="triangle t-right"></div>
              </div>

              <div class="instructions">
                <div class="mobileTitle1 f--c">
                  <div class="round"></div>
                  <div>{{ $t('Dropshipping.Module3.Title5') }}</div>
                </div>
                <div class="mobileSub">{{ $t('Dropshipping.Module3.Sub4') }}</div>
                <div class="triangle t-right"></div>
              </div>
          </div>
          <div class="instructionsImgSet">
            <div class="instructionsImg">
              <oss-img :width="343" :height="155" src="https://img.kakaclo.com/web-img/home/dropshipping/pic_m_img3.png" alt="img" />
            </div>
          </div>
          <div class="foot-btn">
            <el-button class="btn" @click="jump('/mall')">{{ $t('Dropshipping.Module3.StartNow') }}</el-button>
          </div>
        </template>

      </div>
    </div>

    <div class="module4">
      <promotion-blog :list="dropshipping" :title="$t('Dropshipping.Module4.Title1')"></promotion-blog>
    </div>

    <div class="module5">
      <div class="box">
        <div class="title1">{{ $t('Dropshipping.Module5.Title1') }}</div>
        <div class="sub">
          <span @click="navigateToCategory('women')" @mouseover="setHoveredCategory('women')" @mouseout="resetHoveredCategory()" :style="{ color: getCategoryColor('women') }">{{ $t('Dropshipping.Module5.Sub1') }}</span>
          <span @click="navigateToCategory('men')" @mouseover="setHoveredCategory('men')" @mouseout="resetHoveredCategory()" :style="{ color: getCategoryColor('men') }">{{ $t('Dropshipping.Module5.Sub2') }}</span>
          <span @click="navigateToCategory('Accessories')" @mouseover="setHoveredCategory('Accessories')" @mouseout="resetHoveredCategory()" :style="{ color: getCategoryColor('Accessories') }">{{ $t('Dropshipping.Module5.Sub3') }}</span>
        </div>
        <div class="product-list f-b-c" v-loading="listLoading">
          <Product v-for="item in likeProductList" :key="item.kkProductId" :product="item" class="product-item"></Product>
        </div>
        <div class="foot-btn">
            <el-button class="btn" @click="jump('/mall')">{{ $t('Dropshipping.Module3.StartNow') }}</el-button>
        </div>
      </div>
    </div>

    <stylist-module></stylist-module>
    <promotion-module-1></promotion-module-1>

    <div class="module8">
      <div class="box">
        <div class="title1">{{ $t('Dropshipping.Module8.Title1') }}</div>
        <el-collapse v-model="activeNames" @change="handleCollapseChange">
          <el-collapse-item :title="$t('Dropshipping.Module8.Questions1')" name="1" class="questions">
            <div class="answer">{{ $t('Dropshipping.Module8.Answer1') }}</div>
          </el-collapse-item>
          <el-collapse-item :title="$t('Dropshipping.Module8.Questions2')" name="2" class="questions">
            <div class="answer" v-html="$t('Dropshipping.Module8.Answer2')"></div>
          </el-collapse-item>
          <el-collapse-item :title="$t('Dropshipping.Module8.Questions3')" name="3" class="questions">
            <div class="answer">{{ $t('Dropshipping.Module8.Answer3') }}</div>
          </el-collapse-item>
          <el-collapse-item :title="$t('Dropshipping.Module8.Questions4')" name="4" class="questions">
            <div class="answer">{{ $t('Dropshipping.Module8.Answer4') }}</div>
          </el-collapse-item>
          <el-collapse-item :title="$t('Dropshipping.Module8.Questions5')" name="5" class="questions">
            <div class="answer">{{ $t('Dropshipping.Module8.Answer5') }}</div>
          </el-collapse-item>
          <el-collapse-item :title="$t('Dropshipping.Module8.Questions6')" name="6" class="questions">
            <div class="answer">{{ $t('Dropshipping.Module8.Answer6') }}</div>
          </el-collapse-item>
          <el-collapse-item :title="$t('Dropshipping.Module8.Questions7')" name="7" class="questions">
            <div class="answer" v-html="$t('Dropshipping.Module8.Answer7')"></div>
          </el-collapse-item>
          <el-collapse-item :title="$t('Dropshipping.Module8.Questions8')" name="8" class="questions">
            <div class="answer">{{ $t('Dropshipping.Module8.Answer8') }}</div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <div v-if="showPCVideo" style="width: 100%; height: 100%; background-color: #212326; position: fixed; left: 0; top: 0; z-index: 2011">
      <el-dialog :visible.sync="showPCVideo" width="60%">
        <video style="width: 100%" autoplay="autoplay" muted="false" loop controls>
          <source :src="videoPCUrl" type="video/mp4" />
        </video>
      </el-dialog>
    </div>
    <div v-if="showMpbileVideo" style="width: 100%; height: 100%; background-color: #212326; position: fixed; left: 0; top: 0; z-index: 2011">
      <el-dialog :visible.sync="showMpbileVideo" class="mpbile-dialog" width="100%">
        <video style="width: 100%" autoplay="autoplay" muted="false" loop controls>
          <source :src="videoMpbileUrl" type="video/mp4" />
        </video>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import API from '@/api'
import Product from '@/components/Product.vue'
import { log } from 'mathjs'
import PromotionBlog from '../components/PromotionBlog.vue'
import StylistModule from '../components/StylistModule.vue'
import PromotionModule1 from '../components/PromotionModule1.vue'

export default {
  metaInfo: {
    title: 'Clothing Dropshipping Suppliers - KakaClo',
    meta: [
      {
        name: 'description',
        content: 'Looking for reliable clothing dropshipping suppliers? Explore our platform for wholesale clothing and one-stop dropshipping solutions. Get high-quality products and seamless service.'
      }
    ]
  },
  components: { Product, StylistModule, PromotionBlog, PromotionModule1 },
  data() {
    return {
      subtitleImgSrc: 'http://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/home/dropshipping/icon_img1.png',
      titleColor: '#9AC331', // Initial text color
      selectedCategory: '#303133', // Default text color
      hoveredCategory: null,
      backgroundColor: '#FAB55A', // Initial background color
      showPCVideo: false,
      videoPCUrl: '',
      showMpbileVideo: false,
      videoMpbileUrl: '',
      activeNames: ['1'], // 默认展开第一个项
      listLoading: false,
      likeProductList: [],
      listParams: {
        pageSize: 40,
        pageNumber: 1,
        categoryId: undefined,
        code: undefined, // 品类编码
        // materialArray: [], // 材质
        minPrice: undefined, // 区间最小售价
        maxPrice: undefined, // 区间最大售价
        minStock: undefined, // 最小库存
        maxStock: undefined, // 最大库存
        sortName: this.sortName, // 需要排序的字段
        sortType: 'desc', // 排序方式：desc ,asc
        searchName: undefined, // 产品名称
        countryCodeArray: undefined, // 发货国家编码
        timeLine: undefined // 时间
      },
      dropshipping: []
    }
  },
  computed: {
    userId() {
      return this.$store.state.common.userId
    }
  },
  created() {
    // 猜你喜欢
    this.getIndexUserRecs()
    this.getPromotionLatestBlog()
  },
  methods: {
    getIndexUserRecs() {
      this.listLoading = true
      let data = {
        'pageSize': 25,
        'pageNumber': 1,
        'materialArray': [],
        'minPrice': 0,
        'maxPrice': 200,
        'sortType': 'desc',
        'sortName': 1,
        'supplierLevels': []
      }
      API.getOpenNewInProductList(data).then(({ data }) => {
        const list = data.list || []
        if (!list || !list.length) {
          return
        }
        this.likeProductList = data.pageNumber === 1 ? list.slice(0, 5) : [...this.likeProductList, ...list].slice(0, 5)
        console.log(this.likeProductList)
      }).finally(() => {
        this.listLoading = false
      })
    },

    handleCollapseChange(newActiveNames) {
      this.activeNames = newActiveNames.slice(-1)
      console.log(this.activeNames)
    },
    playPCVideo(url) {
      this.videoPCUrl = url
      this.showPCVideo = true
    },

    playMpbileVideo(url) {
      this.videoMpbileUrl = url
      this.showMpbileVideo = true
    },
    jump(path, event_id) {
      if (['/mall'].includes(path)) {
        // sharingLogin()
        window.open(process.env.VUE_APP_MAIN_DOMAIN + path)
        return
      }
      this.$router.push(path)
    },
    navigateToCategory(category) {
      // 实现页面跳转逻辑，可能使用路由或其他导航方式

      location.href = '/product-list/' + category
    },
    setHoveredCategory(category) {
      this.hoveredCategory = category
    },
    resetHoveredCategory() {
      this.hoveredCategory = null
    },
    getCategoryColor(category) {
      return this.hoveredCategory === category ? '#B8D56F' : this.selectedCategory
    },
    changeBackgroundColor(isHovered) {
      this.backgroundColor = isHovered ? '#CB9349' : '#FAB55A'
    },
    changeSubtitleStyle(isHovered) {
      console.log(isHovered)
      this.subtitleImgSrc = isHovered ? 'http://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/home/dropshipping/icon_img28.png' : 'http://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/home/dropshipping/icon_img1.png'
      this.titleColor = isHovered ? '#B8D56F' : '#9AC331'
    },
    getPromotionLatestBlog() {
      API.getPromotionLatestBlog().then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.dropshipping = res.data.Dropshipping
      })
    }
  }

}
</script>

<style lang="scss" scoped>
.dropshipping {

  .box {
    max-width: 1400px;
    margin: 0 auto;
    padding: 16px;
    .title1 {
      font-size: .36rem;
      font-weight: 600;
      line-height: 48px!important;
      color: #303133;
      text-align: center;
      margin-bottom: 16px;
    }
    .sub1 {
      max-width: 751px;
      padding: 0 20px;
      font-size: 16px;
      text-align: center;
      margin: 0 auto;
      line-height: 24px;
      font-family: Poppins, Poppins;
      font-weight: 400;
      font-size: 16px;
      color: #606266;
      font-style: normal;
      text-transform: none;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .module1 {
    background-image: url('https://img.kakaclo.com/web-img/home/dropshipping/bg_img1_1.png');
    background-repeat: no-repeat;
    background-size: 90% 100%;
    background-color: #FFFFFF;

    // height: 678px;
    padding-top: 48px;
    // align-items: flex-end;
    flex-direction: column;
    .box {
      padding: 90px 20px;
    }
    .left {
      width: 50%;
      flex-shrink: 0;
      .subtitle {
         font-size: 18px;
        //font-size: 0.48rem;
        font-weight: regular;
        margin-bottom: 16px;
        display: flex;
        align-items: center;
        cursor: pointer; /* 设置鼠标样式为小手 */
      }
      .subtitleImg {
          height: 20px;
          width:  20px;
          margin-right: 2px;
          transition: transform 0.3s ease-in-out; /* Add a smooth transition effect */
      }

      .subtitle:hover .subtitleImg {
        transform: scale(1.2); /* Example: Increase the size on hover */
      }

      .title {
        font-size: 48px;
        //font-size: 0.48rem;
        font-weight: bold;
        color: #303133;
        margin-bottom: 16px;
      }
      .title2 {
        position: relative;
        font-size: 48px;
        //font-size: 0.48rem;
        font-weight: bold;
        color: #303133;
        display: flex;
        .title3{
          margin-left: 6px;
          color: #9AC331 I !important;
        }
        .wireIcon{
          width: 327px;
          height: 66px;
          position: absolute;
          margin-left: 195px;
          margin-top: 2px;
        }

      }
      .sub {
        font-size: 16px;
        //font-size: .20rem;
        line-height: 24px;
        color:#606266;
        font-weight: 400 !important;
      }

      .btn {
        height: 56px;
        box-sizing: border-box;
        font-size: 18px;
        font-weight: 600;
        background: linear-gradient(90deg, #E7E140 0%, #9AC331 100%);
        color: #fff;
        margin-top: 80px;
        text-align: center;
      }
    }
    .img {
      width: 50%;
      height: auto;
    }

    .platformLogo {
      display: flex;
      align-items: center;
      margin: 0 auto;
      .platformLogoImg {
        width: 240px;
        height: auto;
        margin-top: 100px;
        margin-right: 48px;
        margin-bottom: 60px;

      }
    }
  }

  .module2 {
    padding: 104px 0;
    background-image: url('https://img.kakaclo.com/web-img/home/dropshipping/bg_img2_1.png');
    background-size: 100% 100%;
    .box {
      .title1 {
        font-size: 36px;
        font-weight: 600px;
        line-height: 48px ;
        margin-bottom: unset;

      }
      margin-bottom: -10px;

    }
    .sub1 {
      margin-top: 20px;
      max-width: 800px;
    }
    .item {
      margin-top: 56px;
      .title {
        font-size: 24px;
        font-weight: bold;
        color: #303133;
        margin-bottom: 12px;
      }
      .sub {
        font-size: 16px;
        line-height: 24px;
      }
      .sub:nth-child(2) {
        margin-bottom: 10px;
      }
      .left,.right {
        width: 48.5%;
        height: auto;
        flex-shrink: 0;
        position: relative;
        .leftDescribe1 {
          width: 365px;
          height: 84px;
          background: #124537;
          border-radius: 30px 50px 50px 0px;
          position: absolute;
          bottom: 70px;
          display: flex;
          align-items: center;
          justify-content: center;
          .questions1{
            width: 325px;
            height: 52px;
            font-family: Poppins, Poppins;
            font-weight: 400;
            font-size: 18px;
            color: #FFFFFF;
            line-height: 26px;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }
        }

        .leftDescribe2 {
          width: 353px;
          height: 58px;
          background: #FAB55A;
          border-radius: 50px 30px 0px 50px;
          position: absolute;
          left: 120px;
          bottom: 0px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer; /* 设置鼠标样式为小手 */
          .linkUrl1{
            width: 313px;
            height: 26px;
            font-family: Poppins, Poppins;
            font-weight: 400;
            font-size: 18px;
            color: #FFFFFF;
            line-height: 26px;
            text-align: left;
            font-style: normal;
            text-decoration-line: underline;
            text-transform: none;
            line-height: 26px;

          }
          .leftDescribe2:hover {
            background: #CB9349!important;; /* Change the background color on hover */
          }
        }
        .caption {
          display: flex;
          height: 112px;
          align-items: center;
          margin-left: 104px;
          .captionImg {
            width: 64px;
            height: 64px;
            border-radius: 50%; /* 将边框半径设置为元素宽度的50%，实现圆角 */
            background-color: #fff;
            position: relative;
            margin-right: 12px;
            box-shadow: 0px 6px 30px 5px rgba(77,150,59,0.02), 0px 16px 24px 2px rgba(77,150,59,0.02), 0px 8px 10px -5px rgba(77,150,59,0.04);
            .captionImgSet {
              width: 40px;
              height: 40px;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);

            }
          }
          .captionTitle{
            font-family: Poppins, Poppins;
            font-weight: 500;
            font-size: 20px;
            color: #303133;
            line-height: 28px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            display: block;

          }
          .captionTitleAdditiona{
            font-family: Poppins, Poppins;
            font-weight: 400;
            font-size: 16px;
            color: #909399;
            line-height: 24px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            display: block;

          }
        }
        .selectReason{
          display: flex;
          height: 128px;
          width: 680px;
          background-color:#fff;
          border-radius: 12px;
          align-items: center;
          margin-bottom: 24px;
          margin-right: 40px;
          box-shadow: 0px 6px 30px 5px rgba(77,150,59,0.02), 0px 16px 24px 2px rgba(77,150,59,0.02), 0px 8px 10px -5px rgba(77,150,59,0.04);
          .selectReasonImg{
            margin-top: 5px;
            .selectReasonImgSet {
              width: 40px;
              height: 40px;
              vertical-align: top; /* 将元素垂直对齐到顶部 */
              margin-bottom: 50px;
              margin-left: 24px;

            }

          }
          .selectReasonTitle{
            font-family: Poppins, Poppins;
            font-weight: 500;
            font-size: 20px;
            color: #303133;
            line-height: 28px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            display: block;
            margin-left: 16px;
            margin-bottom: 8px;

          }
          .selectReasonTitleAdditiona{
            font-family: Poppins, Poppins;
            font-weight: 400;
            font-size: 14px;
            color: #909399;
            line-height: 22px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            display: block;
            margin-left: 16px;
            width: 544px;
          }

        }
      }
      .picImg {
        width: 660px;
        height: 608px;
      }
    }
    .advantage{
      display: flex;
      margin-top: 80px;

      .advantageDetails{
        margin-left: 200px;
        justify-content: space-between;
        margin: 0 auto;
        text-align: center;
        .advantageImg{
          width: 120px;
          height: 120px;
        }
        .advantageTitle{
          font-family: Poppins, Poppins;
          font-weight: 500;
          font-size: 20px;
          color: #303133;
          line-height: 28px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }

      }
    }
    .item:nth-child(3) {
      margin-top:56px
    }
  }

  .module3 {
    padding: 200px 0;
    background-color: #fff;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    // height: 678px;
    padding-top: 108px;
    align-items: flex-end;
    .box {
      padding: 0 20px;
      position: relative;
    }

    .instructionsImg{
      text-align: center;
      width: 1062px;
      height: auto;
      margin-left: 168px;
      margin-top: 56px;
    }
    .box1 {
      width: 100%;
      position: absolute;
      top: 151px;
    }
    .top,.bottom  {
      width: 100%;
      flex-shrink: 0;
      padding-bottom: 32px;
      display: flex;
      margin-top: 15px;
      .instructions{
        width: 395px;
        height: 152px;
        padding: 32px 50px;
        box-sizing: border-box;
        background-color: #fff;
        border-radius: 12px;
        position: relative;
        box-shadow: 0px 4px 12px 2px rgba(77,150,59,0.1);
        border-radius: 12px 12px 12px 12px;
        .title2 {
          font-size: 24px;
          line-height: 32px;
          font-weight: bold;
          color: #303133;
          margin-bottom: 8px;
          position: relative;
          left: -16px;
          .round {
            width: 8px;
            height: 8px;
            background-color: #9AC331;
            border-radius: 50%;
            margin-right: 8px;
          }
        }
        .sub2 {
          font-size: 16px;
          line-height: 24px;
          color: #606266;
        }
        .triangle {
          border-style: solid;
          border-color: transparent;
          border-width: 10px 0 10px 20px;
          border-left-color: #fff;
          position: absolute;
          right: -16px;
          top: 66px;
        }
        .t-right {
          border-width: 10px 20px 10px 0px;
          border-right-color: #fff;
          right: unset;
          left: -16px;
          top: 66px;
        }
      }
      .title1—1 {
         font-size: 18px;
        //font-size: 0.48rem;
        font-weight: bold;
        margin-bottom: 16px;
        color: #9AC331;
        display: flex;
        align-items: center;

      }
      .title {
        // font-size: 48px;
        font-size: 0.48rem;
        font-weight: bold;
        margin-bottom: 16px;
        color: #303133;
      }
      .sub {
        font-size: .20rem;
        margin-bottom: 16px;
      }

    }
    .img {
      width: 50%;
      height: auto;
    }
    .foot-btn {
      text-align: center;
      margin-top: 40px;
      border-radius: 2px 2px 2px 2px;
      .btn{
        background-color: #9AC331;
        width: 118px;
        height: 40px;
        box-sizing: border-box;
        font-size: 16px;
        font-weight: 500;
        color: #fff;
        text-align: center;
      }

    }
  }

  .module4 {
    background-color: #fff;
  }

  .module5 {
    background-color: #fff;
    .box{
        padding: 200px 16px;
    }
    .title1 {
      margin-bottom: 16px;
    }
    .product-list{
      margin-top: 40px;
      text-align: left;

      > div {
        width: 19.1%;
        padding-bottom: 20px;
      }

    }

    .sub{
      display: flex;
      justify-content: space-between; /* 平均间距 */
      align-items: center; /* 水平居中 */
      font-family: Poppins, Poppins;
      font-weight: 500;
      font-size: 20px;
      color: #303133;
      line-height: 28px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin: 56px 310px 0px;
    }
    .sub span:hover {
      cursor: pointer;
    }

    .item {
      width: 24%;
      .img {
        width: 100%;
        max-height: 376px;
        margin-bottom: 12px;
      }
    }
    .type {
      width: inherit;
      height: 32px;
      padding: 0 16px;
      border-radius: 20px;
      background-color: #F7F8FB;
      margin-bottom: 8px;
      color: #909399;
    }
    .title {
      color: #303133;
      font-size: 20px;
      line-height: 28px;
      margin-bottom: 17px;
    }
    .date {
      color: #909399;
      font-size: 14px;
    }
    .more {
      color: #9AC331;
      font-size: 16px;
    }

    .foot-btn {
      text-align: center;
      margin-top: 40px;
      border-radius: 2px 2px 2px 2px;
      .btn{
        background-color: #9AC331;
        width: 118px;
        height: 40px;
        box-sizing: border-box;
        font-size: 16px;
        font-weight: 500;
        color: #fff;
        text-align: center;
      }

    }
  }

  .module6 {
    background-image: url('https://img.kakaclo.com/web-img/home/dropshipping/bg_img4.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    // height: 678px;
    padding-top: 48px;
    align-items: flex-end;
    .box {
      padding: 0 20px;
    }
    .left {
      width: 45%;
      flex-shrink: 0;
      padding-bottom: 10px;
      .title1—1 {
         font-size: 18px;
        //font-size: 0.48rem;
        font-weight: bold;
        margin-bottom: 16px;
        color: #9AC331;
        display: flex;
        align-items: center;

      }
      .title {
        // font-size: 48px;
        font-size: 0.48rem;
        font-weight: bold;
        margin-bottom: 16px;
        color: #303133;
      }
      .sub {
        font-size: .20rem;
        margin-bottom: 16px;
      }

      .btn {
        width: 168px;
        height: 56px;
        box-sizing: border-box;
        font-size: 18px;
        font-weight: bold;
        background: linear-gradient(90deg, #E7E140 0%, #9AC331 100%);
        color: #fff;
        margin-top: 80px;
      }
    }
    .img {
      width: 50%;
      height: auto;
    }
  }

  .module7 {
    padding: 104px 0;
    background-image: url('https://img.kakaclo.com/web-img/home/dropshipping/bg_img5.png?x-oss-process=image/resize,w_1280,h_281,m_fill/format,webp');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .box {
      flex-direction: column;
    }
    .title1 {
      color: #fff;
      font-size: 48px;
      line-height: 68px;
      margin-bottom: 16px;
    }
    .sub1 {
      color: #fff;
      font-size: 18px;
      line-height: 26px;
      margin-bottom: 48px;
    }
    .btn {
      height: 56px;
      background: linear-gradient(90deg, #E7E140 0%, #9AC331 100%);
      border-radius: 4px 4px 4px 4px;
      font-size: 18px;
      font-weight: 600;
      color: #fff;
      text-align: center;
    }
  }
  .module8 {
    padding: 104px 0;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-color: #fff;
    .box {
      flex-direction: column;

    }
    .title1 {
      margin-bottom: 56px;
    }
    /deep/ .el-collapse {
      border-top: none !important;;
    }
    /deep/ .el-collapse-item__arrow {
      font-weight: bold;
      color: #909399;
    }
    /deep/ .questions .el-collapse-item__header {
      font-family: Poppins, Poppins;
      font-weight: 500;
      font-size: 20px;
      color: #303133;
      line-height: 28px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      height: 80px; /* 设置收缩状态下的高度 */
      border-top: none;

    }
    .answer {
      font-family: Poppins, Poppins;
      font-weight: 400;
      font-size: 16px;
      color: #606266;
      line-height: 24px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
  }

  @media screen and (max-width: 1000px) {

    .box {
      padding: 0 16px;
      display: block;
      text-align: center;
      .sub1 {
        font-size: 14px;
        line-height: 22px;
      }

      .mobileTitle1 {
        font-size: .36rem;
        font-weight: bold;
        color: #303133;
        text-align: center;
        margin-bottom: 16px;
      }
      .mobileSub {
        font-family: Poppins, Poppins;
        font-weight: 400;
        font-size: 10px;
        color: #606266;
        line-height: 16px;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
      img {
        width: 100%;
        height: 100%;
      }

    }

    .module1{
      background-image: url('https://img.kakaclo.com/web-img/home/dropshipping/bg_m_img1.png');
      background-repeat: no-repeat;
      background-size:100%;
      background-color: #FFFFFF;
      .box {
        padding: 10px;

      }
      .mobileSubtitle{
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 13px;
        color: #9AC331;
        line-height: 20px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        display: flex;
        margin-left: 44px;
        align-items: center;
        cursor: pointer;
        margin-bottom: 12px;

      }
      .mobileSubtitleImg {
        height: 20px;
        width:  20px;
        margin-right: 2px;
        transition: transform 0.3s ease-in-out; /* Add a smooth transition effect */
      }

      .subtitle:hover .subtitleImg {
        transform: scale(1.2); /* Example: Increase the size on hover */
      }

      .mobileTitle{
        font-family: Poppins, Poppins;
        font-weight: bold;
        font-size: 28px;
        color: #303133;
        line-height: 36px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        display: flex;
        margin-left: 2px;

      }
      .mobileTitle2 {
        font-family: Poppins, Poppins;
        font-weight: bold;
        font-size: 28px;
        color: #303133;
        line-height: 36px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        display: flex;
        margin-left: 10px;
        .title3{
          margin-left: 6px;
          color: #9AC331;
        }
        .wireIcon{
          width: 210px;
          height: 42px;
          position: absolute;
          margin-left: 116px;
          margin-top: 2px;
        }
      }
      .btn {
        font-family: Poppins, Poppins;
        font-size: 16px;
        font-style: normal;
        text-transform: none;
        height: 40px;
        box-sizing: border-box;
        font-weight: bold;
        background: linear-gradient(90deg, #E7E140 0%, #9AC331 100%);
        color: #fff;
        margin-top: 40px;
        text-align: center;

      }
      .img {
        margin-top: 40px;
        width: 343px;
        height: auto;
      }

      .platformLogoTop{
        margin-top: 40px;
        display: flex;
        text-align: center;
        justify-content: center; /* 居中对齐 */
        .platformLogoImg{
          width: 109px;
          height: 22px;
          img {
            height: auto;
            width: 100%;
          }
        }

      }
      .platformLogoBottom{
        margin-top: 16px;
        display: flex;
        text-align: center;
        justify-content: center; /* 居中对齐 */
        margin-bottom: 48px;
        margin-right: 8px;
        .platformLogoImg{
          width: 109px;
          height: 22px;
          img {
            height: auto;
            width: 100%;
          }
        }
      }

    }
    .module2{
      padding: 48px 0px 0px 0px;

      background-image: url('https://img.kakaclo.com/web-img/home/dropshipping/bg_m_img2_1.png?x-oss-process=image/resize,w_374,h_2270,m_fill/format,webp');
      background-repeat: no-repeat;

      .mobileSub{
        font-weight: 400;
        font-size: 14px;
        margin-bottom: 32px;
        line-height:22px;
      }
      .box{
        text-align: center;
        .mobileTitle1{
          font-size: 20px;
          font-weight: 600;
        }
      }
      .mobilePicImg{
        position: relative;
        margin-bottom: 40px;
        .mobilePicImgSet{
          height: auto;

        }

        .mobileLeftDescribe1{
          position: absolute;
          background: #124537;
          border-radius: 30px 50px 50px 0px;
          height: 60px;
          width: 270px;
          display: flex;
          align-items: center;
          justify-content: center;
          bottom: 56px;
          .questions1{
            width: 238px;
            height: 36px;
            font-family: Poppins, Poppins;
            font-weight: 400;
            font-size: 12px;
            color: #FFFFFF;
            line-height: 18px;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }
        }
        .mobileLeftDescribe2 {
          width: 241px;
          height: 44px;
          background: #FAB55A;
          border-radius: 50px 30px 0px 50px;
          position: absolute;
          bottom: 0px;
          display: flex;
          align-items: center;
          justify-content: center;
          right: 0px;
          bottom: 3px;
          .linkUrl1{
            width: 209px;
            height: 18px;
            font-family: Poppins, Poppins;
            font-weight: 400;
            font-size: 12px;
            color: #FFFFFF;
            line-height: 18px;
            text-align: left;
            font-style: normal;
            text-decoration-line: underline;
            text-transform: none;
          }
          .leftDescribe2:hover {
            background: #CB9349!important;; /* Change the background color on hover */
          }
        }

      }
      .captionSet{
        .caption {
          display: flex;
          height: 100px;
          align-items: center;
          margin-left: 15px;
          .captionImg {
            width: 64px;
            height: 64px;
            border-radius: 50%; /* 将边框半径设置为元素宽度的50%，实现圆角 */
            background-color: #fff;
            position: relative;
            margin-right: 12px;
            flex: 64px 0 0;
            box-shadow: 0px 6px 30px 5px rgba(77,150,59,0.02), 0px 16px 24px 2px rgba(77,150,59,0.02), 0px 8px 10px -5px rgba(77,150,59,0.04);
            .captionImgSet {
              width: 40px;
              height: 40px;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);

            }
          }
          .captionTitle{
            font-family: Poppins, Poppins;
            font-weight: 500;
            font-size: 16px;
            color: #303133;
            line-height: 24px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            display: block;

          }
          .captionTitleAdditiona {
            font-family: 'Poppins', sans-serif;
            font-weight: 400;
            font-size: 13px;
            color: #909399;
            line-height: 20px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            display: block;
            word-wrap: break-word; /* Enable word wrapping */

          }
        }

      }
      .selectReasonSet{

        .selectReason{
          display: flex;
          height: 172px;
          background-color: #FFFFFF;
          border-radius: 12px;
          align-items: center;
          margin-bottom: 24px;
          box-shadow: 0px 6px 30px 5px rgba(77,150,59,0.02), 0px 16px 24px 2px rgba(77,150,59,0.02), 0px 8px 10px -5px rgba(77,150,59,0.04);
          .selectReasonImg{
            margin-top: unset;
            .selectReasonImgSet {
              width: 40px;
              height: 40px;
              vertical-align: top; /* 将元素垂直对齐到顶部 */
              margin-bottom: 50px;
              margin-left: 24px;

            }

          }
          .selectReasonTitle{
            font-family: Poppins, Poppins;
            font-weight: 500;
            font-size: 16px;
            color: #303133;
            line-height: 24px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            display: block;
            margin-left: 16px;
            margin-right: 20px;

            word-wrap: break-word; /* 自动换行 */
            overflow-wrap: break-word; /* 允许在断行处换行 */
          }
          .selectReasonTitleAdditiona{
            font-family: Poppins, Poppins;
            font-weight: 400;
            font-size: 13px;
            color: #909399;
            line-height: 20px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            display: block;
            margin-left: 16px;
            margin-right: 20px;
            word-wrap: break-word; /* 自动换行 */
            overflow-wrap: break-word; /* 允许在断行处换行 */
          }
        }
      }

      .advantage{
        display: block;
        margin-top: 40px;
        .advantageDetails{
          justify-content: space-between;
          margin: 20px auto;
          .advantageImg{
            width: 120px;
            height: 96px;
          }
          .advantageTitle{

            font-family: Poppins, Poppins;
            font-weight: 500;
            font-size: 14px;
            color: #303133;
            line-height: 22px;
            font-style: normal;
            text-transform: none;
            text-align: center;

          }

        }

        .advantageTop{
          display: flex;
          text-align: center;
          justify-content: space-between;

        }
        .advantageMiddle{
          display: flex;
          text-align: center;
          justify-content: space-between;

        }
        .advantageBottom{
          display: flex;
          text-align: center;
          justify-content: space-between;

        }
      }

    }

    .module3{
      padding: 96px 0px 0px 0px;
      .box .mobileTitle1 {
          font-weight: 600;
          font-size: 20px;
          line-height: 28px;
      }
      .instructionsSet{
        flex-shrink: 0;
        padding-bottom: 10px;
        text-align: center;
        margin-top: 32px;
        .instructions{
          height: 114px;
          padding: 20px 20px;
          box-sizing: border-box;
          background-color: #fff;
          box-shadow: 0px 4px 12px 2px rgba(77,150,59,0.1);
          border-radius: 12px;
          position: relative;
          align-items: center;
          margin-bottom: 28px;
          .mobileTitle1 {
            font-size: 18px;
            line-height: 26px;
            position: relative;
            margin-bottom: unset;
            padding-left: 10px;
            .round {
              width: 8px;
              height: 8px;
              background-color: #9AC331;
              border-radius: 50%;
              margin-right: 8px;
            }
          }
          .mobileSub {
            font-weight: 400;
            font-size: 14px;
            line-height: 22px;
            text-align: left;
            margin-bottom: unset;
            padding-left: 27px;
          }
        }
      }
      .instructionsImgSet{
        text-align: center;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        .instructionsImg{
            width: auto;
            height: auto;
            margin-left:unset;
            margin-top:unset;
        }
      }

    }

    .module4 {
      padding: 96px 0;
    }

    .module7 {
        padding: 104px 0;
        background-image: url('https://img.kakaclo.com/web-img/home/dropshipping/bg_m_img3.png?x-oss-process=image/resize,w_375,h_220,m_fill/format,webp');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        .box {
          flex-direction: column;
        }
        .title1 {
          color: #fff;
          font-size: 22px;
          line-height: 30px;
          margin-bottom: 12px;
        }
        .sub1 {
          color: #fff;
          font-size: 14px;
          line-height: 22px;
          margin-bottom: 28px;
        }
        .btn {
          height: 40px;
          background: linear-gradient(90deg, #E7E140 0%, #9AC331 100%);
          border-radius: 4px 4px 4px 4px;
          font-size: 16px;
          font-weight: bold;
          color: #fff;
          text-align: center;
        }
      }

    .module8 {
      padding: 48px 0;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-color: #fff;
      .box {
        flex-direction: column;

      }
      .title1 {
        margin-bottom: 40px;
        font-weight: 600;
        font-size: 20px;
        line-height: 28px !important;
      }

      /deep/ .questions .el-collapse-item__header {
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 16px;
        color: #303133;
        line-height: 24px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        height: 64px; /* 设置收缩状态下的高度 */

      }
      .answer {
        font-family: Poppins, Poppins;
        font-weight: 400;
        font-size: 14px;
        color: #606266;
        line-height: 20px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
    }

    .module5 {
      background-color: #fff;
      padding: 50px 0px;

      .box {
        max-width: unset;
        padding: 20px 16px;
        .title1 {
          font-size: 20px;
          line-height: 28px !important;
          font-weight: 600;
          color: #303133;
          text-align: center!important;;
          margin-bottom: 28px;
          width: unset;
        }

      }

      .product-list{
        margin-top: 20px;
        flex-wrap: wrap;

        > div {
          width: 48%;
        }

      }

      .sub{
        display: flex;
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 13px;
        color: #303133;
        line-height: 28px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        margin: 0px 2% 0px;
        width: unset;
        height: 20px;
      }

      .item {
        width: 48%;
        .img {
          width: 100%;
          max-height: 376px;
          margin-bottom: 12px;
        }
      }
      .type {
        width: inherit;
        height: 32px;
        padding: 0 16px;
        border-radius: 20px;
        background-color: #F7F8FB;
        margin-bottom: 8px;
        color: #909399;
      }
      .title {
        color: #303133;
        font-size: 20px;
        line-height: 28px;
        margin-bottom: 17px;
      }
      .date {
        color: #909399;
        font-size: 14px;
      }
      .more {
        color: #9AC331;
        font-size: 16px;
      }
      .foot-btn {
        text-align: center;
        margin-top: 40px;
        border-radius: 2px 2px 2px 2px;
        .btn{
          background-color: #9AC331;
          width: 118px;
          height: 40px;
          box-sizing: border-box;
          font-size: 16px;
          font-weight: 500;
          color: #fff;
          text-align: center;
        }

      }
    }
  }

}

</style>
